const axios = require('axios').default;
import {
	AboutProject
} from '../../../../public/static/AboutProject.js';
import comm from './common.js';
import {
	Error,
	Log,
	Warn
} from '../../message-console/message-console.js'
import {Stoken,logout,_Stoken,stopInterval,IsLogin,refreshaccessToken,IsCGY} from '../../../store/router.js'
import route from '../../../router/index.js';
console.log(AboutProject)
var apiUrl = AboutProject.ApiUrl;

//添加一个匹配关系 根据当前网页的主机地址 链接不同的服务
var hostOrgin=location.origin;//当前主机地址
var hostMap=AboutProject.ServerMap||{};//主机地址的匹配
var FISMap=Object.keys(hostMap).length>0;
if(FISMap){
	if(hostMap[hostOrgin]&&hostMap[hostOrgin]['apiUrl']&&hostMap[hostOrgin]['apiUrl']!=''){
		apiUrl=hostMap[hostOrgin]['apiUrl'];
	}
}

if (!comm.checkString(apiUrl) || apiUrl === "") Error(`ApiUrl is empty`);
apiUrl += AboutProject.ApiBase;
var ApiType = "WebApi";
var headers = {};
if (ApiType.includes("webservice")) headers['Content-Type'] = "text/xml;charset=utf-8";

//check test url is connected.
export var ApiUrl = apiUrl;
export function XMLRequest(paramObj, fun, errFun) {
	var xmlhttp = null;
	/*创建XMLHttpRequest对象，
	 *老版本的 Internet Explorer（IE5 和 IE6）使用 ActiveX 对象：new ActiveXObject("Microsoft.XMLHTTP")
	 * */
	if (window.XMLHttpRequest) {
		xmlhttp = new XMLHttpRequest();
	} else if (window.ActiveXObject) {
		xmlhttp = new window.ActiveXObject("Microsoft.XMLHTTP");
	}
	/*判断是否支持请求*/
	if (xmlhttp == null) {
		window.BH.message('你的浏览器不支持XMLHttp');
		return;
	}
	/*请求方式，并且转换为大写*/
	var httpType = (paramObj.type || 'GET').toUpperCase();
	/*数据类型*/
	var dataType = paramObj.dataType || 'json';
	/*请求接口*/
	var httpUrl = paramObj.httpUrl || '';
	/*是否异步请求*/
	var async = paramObj.async || true;
	/*请求参数--post请求参数格式为：foo=bar&lorem=ipsum*/
	var paramData = paramObj.data || [];
	var requestData = '';
	for (var name in paramData) {
		requestData += name + '=' + paramData[name] + '&';
	}
	requestData = requestData == '' ? '' : requestData.substring(0, requestData.length - 1);
	console.log(requestData)

	/*请求接收*/
	xmlhttp.onreadystatechange = function() {
		if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
			/*成功回调函数*/
			fun(xmlhttp.responseText);
		} else {
			/*失败回调函数*/
			errFun;
		}
	}

	/*接口连接，先判断连接类型是post还是get*/
	if (httpType == 'GET') {
		xmlhttp.open("GET", httpUrl, async);
		xmlhttp.send(null);
	} else if (httpType == 'POST') {
		xmlhttp.open("POST", httpUrl, async);
		//发送合适的请求头信息
		xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
		xmlhttp.send(requestData);
	}
}
export function dorequest(t,w) {
	function transRequestR(response) {
		Log(response)
		this.urlsign = response.status === 200 ? 'true' : 'false';
		Boolean(this.urlsign) && (this.urlmesage = response.statusText);
		if (response.data) {
			if (comm.checkObj(response.data)) {
				let obj = response.data;
				this.sign = obj.rescode;
			} else Warn(`pay attention to response type ${response.url}`);
		}
		return {
			sign: '',
			message: '',
			data: [],
			fromUrl: '',
			urlsign: this.urlsign,
			urltext: this.urlmesage
		}
	}

	function check(t) {
		if (!t) {
			Error('lock of param')
			return false;
		}
		if (!t.url) {
			Error('lock of url')
			return false;
		}
		return true;
	}
	
	function makedata(name, data) {
		if (!data) return {};
		console.log(data)
		if (ApiType.includes('webservice')) {
			let param = '';
			for (let i in data)
				param += `<${i}>${data[i]}</${i}>`;
			let datatemplate =
				`
			<?xml version="1.0" encoding="utf-8"?>
			<soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
			  <soap:Body>
				<${name} xmlns="http://www.cnlean.net/">
				  ${param}
				</${name}>
			  </soap:Body>
			</soap:Envelope>`
			return datatemplate;
		} else return data;
	}

	function requestHeader(){
		let auth=AboutProject.ApiControlAuthen;
		let arr=String(t.url).split('/')
		arr=arr.length>0?arr[0]:false;
		for(let i in auth){
			if((arr&&auth[String(arr)]) ||String(t.url)=='Task/checkVailRefresh'||String(t.url)=='Task/refreshToken'){
				if(!ApiType.includes("webservice"))
					t._headers={
						"Content-Type":'application/json;charset=utf-8',
						"Authorization":`Bearer ${String(t.url)=='Task/checkVailRefresh'||String(t.url)=='Task/refreshToken'?_Stoken():Stoken()}`
					}
				if(String(t.url)=='Web/ReciveFile')
					t._headers['Content-Type']='multipart/form-data';
			} 
		}
		if(String(t.url)!='Task/checkVailRefresh')
			console.log(t._headers)
	}
	
	function makeurl(t) {
		if(!t.url.includes('http')){
			if (ApiType.includes('webservice'))
				return t.baseUrl ? t.baseUrl : apiUrl;
			return (t.baseUrl ? t.baseUrl : apiUrl) + t.url
		}else return t.url;
		
	}

	function request(t,w) {
		if(String(t.url)!='Task/checkVailRefresh')
			console.log(t)
		t._headers=headers;
		requestHeader();
		axios({//传递数据中包含Date类型数据 会自动根据时区时间转化
			method: 'post',
			url: makeurl(t),
			dataType: 'json',
			timeout: 60000,
			data: makedata(makeurl(t), t.data),
			headers: t._headers,
			withCredentials: !t.withCredentials ? true : t.withCredentials
		}).then(function(response) {
			//等获取到数据以后再跳转到login界面
			// transRequestR(response);
			if(String(t.url)!='Task/checkVailRefresh')
				Log(response)
			if (response.status == 200) {
				if (response.data.code) {
					if(String(t.url)!='Task/checkVailRefresh')
						Log(response)
					if (response.data.code == 'SUCCESS') {
						// console.log(t)
						if (t.success) {
							t.success(response)
						}
						if (t.loadingcontrol) {
							if(!t.notLoadSign||!t.notLoadSign.includes('success'))
								t.loadingcontrol('success')
						}
					} else if (response.data.code == 'FAIL') {
						if (t.loadingcontrol) {
							if(!t.notLoadSign||!t.notLoadSign.includes('fail'))
								t.loadingcontrol('fail')
						}
						if (t.fail) {
							t.fail(response)
						} else {
							window.BH.message(response.data.value)
							Log(response)
						}
					} else { //API runing in error
						Log(response)
						if (response.data.errcode && Boolean(response.data.errcode)) {
							if (t.error) {
								t.error(response)
							} else {
								window.BH.message(response.data.errmsg);
							}
						}
						if (t.loadingcontrol) {
							if(!t.notLoadSign||!t.notLoadSign.includes('error'))
								t.loadingcontrol('error')
						}

					}
				} else {
					if (t.loadingcontrol) {
						if(!t.notLoadSign||!t.notLoadSign.includes('requesterr'))
							t.loadingcontrol('requesterr')
					}
					//alert
				}

			} else {
				if (t.loadingcontrol) {
					if(!t.notLoadSign||!t.notLoadSign.includes('fail'))
						t.loadingcontrol('fail')
				}
				if (t.requestfail) {
					t.fail(response)
				} else { //Project_001
					//alert
				}
			}
		},(error)=>{
			//没有授权等
			console.log(error,error.response)
			if(error.response){
				let code='',value='';
				try{
					let obj=JSON.parse(error.response.data.value);
					code=obj.code;
					value=obj.value;
				}catch(e){
					//TODO handle the exception
					code=error.response.status,value=error.response.statusText;
				}
				if(String(t.url)=='Task/checkVailRefresh'){
					stopInterval();
				} 
				if(error.response.status==401){
					// if(IsLogin){
					// 	alert('授权过期，请重新登录');
					// 	logout();
					// 	route.push('/')
					// }
					if(String(t.url).indexOf('Task/refreshToken')>-1){//如果需要停止重复刷新token话，同时关闭定时器
						if(IsLogin){
							window.BH.message('授权过期，请重新登录');
							logout(()=>{
								if(IsCGY){
									window.location.href="/cgy.html";
								}else 
									window.location.href="/";
							});
							
						}
					}else{
						if(!w){
							console.log('刷新token')
							//刷新token
							window.BH.base.http({
								url:'Task/refreshToken',
								data:{
									token:Stoken(),
									_token:_Stoken()
								},
								success:(res)=>{
									console.log('修改返回的token')
									let replaceres=refreshaccessToken(res.data.value.stoken,res.data.value.audience);
									console.log(replaceres)
									console.log(res.data.value.stoken,res.data.value.audience)
									window.BH.base.http(t,'refresh')
								},
								fail:(res)=>{
									console.log('刷新token未成功',res);
									if(res.data.value=='登陆失效，请重新登录'&&route.history.current.fullPath!='/Login'){
										window.BH.message(res.data.value);
										logout(()=>{
											if(IsCGY){
												window.location.href="/cgy.html";
											}else 
												window.location.href="/";
										});
										
									}
								}
							});
							// alert(`状态码:${code},详细信息:${value}`);
						}else console.log('刷新token未成功')
					}
					
				}else{
					if (t.loadingcontrol) {
						if(!t.notLoadSign||!t.notLoadSign.includes('error'))
							t.loadingcontrol('error')
					}
					window.BH.message(`访问错误，请联系管理员：状态码:${code},详细信息:${value}`);
					return;
				}
			}
			else{
				if (t.loadingcontrol) {
					if(!t.notLoadSign||!t.notLoadSign.includes('error'))
						t.loadingcontrol('error',error)
				}
				//网络故障
				if(error=='Error: timeout of 50000ms exceeded')
					window.BH.message('访问超时，请重新再试');
				else
					window.BH.message(error);
				if(String(t.url)=='Task/checkVailRefresh'){
					stopInterval();
				} 
			} 
		}).catch(function(error) {
			if (t.loadingcontrol) {
				if(!t.notLoadSign||!t.notLoadSign.includes('error'))
					t.loadingcontrol('error',error)
			}
			window.BH.message(error);
			Log(error)
			// if (!error) {
			// 	//alert
			// 	Log(!!error)
			// }

		});
	}
	try {
		if (check(t)) {
			request(t,w)
		}
	} catch (e) {
		//TODO handle the exceptionProject_002
		//alert
		Error(e)
	}

}
